/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */

/* INICIO - Estructura de configuración de tiendas grupo DIFARE: Cada nueva tienda se agrega en esta constante onlineStores */
/*
  ESTRUCTURA DE TIENDA
  * description: Array[{displayName: string, languageId: string}]
  * storeId: string
  * identifier: string
*/
export const onlineStores = [
  {
    description: [
      {
        displayName: "Pharmacys",
        languageId: "-1000",
      },
    ],
    storeId: "10151",
    identifier: "Pharmacys",
  },
  {
    description: [
      {
        displayName: "Cruz Azul",
        languageId: "-1000",
      },
    ],
    storeId: "10651",
    identifier: "Cruz Azul",
  },
];
/* FIN - Estructura de configuración de tiendas grupo DIFARE: Cada nueva tienda se agrega en esta constante onlineStores */
